import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Company {
  id: string
  slug: string
  name: string
  legalName: string
  cnpj: string
  email?: string
  phone?: string
  addressId?: string
}

interface CompanyState {
  company: Company | null
  setCompany: (company: Company) => void
  clear: () => void
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set) => ({
      company: null,

      setCompany: (company) => {
        set({ company })
      },

      clear: () => {
        set({ company: null })
      },
    }),
    {
      name: 'company-storage',
    },
  ),
)
